import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table, Radio, 
    Space, Empty, Popconfirm, Modal, Cascader, Checkbox, Tooltip, Tag
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateSystemExtension, putTemplateSystemExtension, 
    deleteSystemExtensionList, deleteSystemExtension, putAllowManuallySystemExtension
} from "../../../axios/api.device"
import { gaEvent } from "../../../withTracker"

import { useTranslation } from "react-i18next";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentSystemExtension = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [enumExtension, setEnumExtension] = useState<string>("AllowedSystemExtensions");
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<any>([]);
    const [allowIsTrue, setAllowIsTrue] = useState<boolean>(true);
    const [extensionModalVisible, setExtensionModalVisible] = useState<boolean>(false);
    const [isEditExtension, setIsEditExtension] = useState<boolean>(false);
    const [selectedExtensionId, setSelectedExtensionId] = useState<string>("");
    const [isDisable, setIsDisable] = useState<boolean>(false);
    const [dataForm] = Form.useForm();

    const { t } = useTranslation();

    const modeMapping: any = {
        AllowedSystemExtensions: t("AllowedSystemExtensions"),
        AllowedSystemExtensionTypes: t("AllowedSystemExtensionTypes"),
        AllowedTeamIdentifiers: t("AllowedTeamIdentifiers"),
    }

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = async () => {
        await getTemplateSystemExtension(templateId).then((res) => {
            if (res.length > 0) {
                setAllowIsTrue(res[0]?.allowUserOverrides);
                setShowTable(2);
                setData(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            var params: any = {}
            if (res.extensionMode === "AllowedSystemExtensions") {
                res.packageList = res.packageList ? res.packageList.filter((item: any) => item) : [];
                params = res;
            }
            if (res.extensionMode === "AllowedSystemExtensionTypes") {
                params = res
            }
            if (res.extensionMode === "AllowedTeamIdentifiers") {
                params["extensionMode"] = res.extensionMode;
                params["teamIdentifierList"] = res.teamIdentifierList.split("\n");
            }
            params["allowUserOverrides"] = allowIsTrue;
            params["id"] = selectedExtensionId;
            
            putTemplateSystemExtension(templateId, params).then(() => {
                updateTemplate();
                notification.success({ message: t("操作成功") });
                dataForm.resetFields();
                setExtensionModalVisible(false);
                setSelectedExtensionId("");
                setEnumExtension("AllowedSystemExtensions");
                getDataInfo();
            })
        })
    }

    const removeSystemExtension = (id: string) => {
        deleteSystemExtension(templateId, id).then(() => {
            notification.success({ message: t("操作成功") });
            if (data.length === 1) {
                setData([]);
                updateTemplate();
            }
            getDataInfo();
        })
    }

    const deleteTemplateClick = () => {
        deleteSystemExtensionList(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            setData([]);
            getDataInfo();
        })
    }

    const addExtension = () => {
        dataForm.resetFields();
        setIsEditExtension(false);
        setExtensionModalVisible(true);
    }

    const editExtension = (row: any) => {
        if (row.extensionMode === "AllowedTeamIdentifiers") {
            dataForm.setFieldsValue({
                extensionMode: row.extensionMode,
                teamIdentifierList: row.teamIdentifierList.join("\n")
            })
        } else {
            dataForm.setFieldsValue(row)
        }
        setSelectedExtensionId(row.id);
        setEnumExtension(row.extensionMode);
        setIsEditExtension(true);
        setExtensionModalVisible(true);
    }

    const allowManually = () => {
        if (data.length === 0) {
            notification.warning({message: t("请先添加扩展")})
        } else {
            putAllowManuallySystemExtension(templateId, allowIsTrue).then(() => {
                setAllowIsTrue(allowIsTrue);
                updateTemplate();
                getDataInfo();
                notification.success({ message: t("操作成功") });
            })
        }
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("System Extension")}</Col>
                <Col style={{ marginLeft: 36 }}>
                    <Tooltip title={t("可在macOS 10.15及更高版本中使用")}>
                        <Tag color="cyan">macOS 10.15+</Tag>
                    </Tooltip>
                </Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <Row style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>{t("配置系统扩展, 以批准托管Mac机器上的网络、驱动程序和安全扩展")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button disabled={isDisable} onClick={() => { addClick() }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <>
                        <div className="tAr" style={{display: "flex", justifyContent: "space-between"}}>
                            <Space>
                                <span style={{color: "#ff4d4f", lineHeight: 1}}>*</span>
                                <span>{t("允许用户手动批准系统扩展")}: </span>
                                <Radio.Group defaultValue={allowIsTrue} onChange={(e) => { setAllowIsTrue(e.target.value) }}>
                                    <Radio value={true}>{t("是")}</Radio>
                                    <Radio value={false}>{t("否")}</Radio>
                                </Radio.Group>
                            </Space>
                            <Button type="primary" onClick={ addExtension }><PlusOutlined />{t("添加系统扩展")}</Button>
                        </div>
                        <Table 
                            dataSource={data} 
                            rowKey="id"
                            style={{ width: "100%" ,marginLeft:8}}
                            locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                        >
                            <Table.Column
                                title={t("系统扩展类型")}
                                key="extensionMode"
                                dataIndex="extensionMode"
                                render={value => modeMapping[value]}
                            ></Table.Column>
                            <Table.Column
                                title={t("团队标识符")}
                                key="teamIdentifier"
                                dataIndex="teamIdentifier"
                                render={(value, row: any) => {
                                    if (row.extensionMode === "AllowedTeamIdentifiers") {
                                        return row?.teamIdentifierList.join(";")
                                    } else {
                                        return value
                                    }
                                }}
                            ></Table.Column>
                            <Table.Column
                                title={t("其它")}
                                key="packageList"
                                dataIndex="packageList"
                                render={(value, row: any) => {
                                    if (row.extensionMode === "AllowedSystemExtensions") {
                                        return value?.join(";") ? `${t("程序包标识")}: ${value?.join(";")}` : ""
                                    } 
                                    if (row.extensionMode === "AllowedSystemExtensionTypes") {
                                        return row?.extensionType.join(";") ? `${t("扩展类别")}: ${row?.extensionType.join(";")}` : ""
                                    }
                                    if (row.extensionMode === "AllowedTeamIdentifiers") {
                                        return ""
                                    }
                                }}
                            ></Table.Column>
                            <Table.Column
                                title={t("操作")}
                                key="id"
                                dataIndex="id"
                                render={(id, row) => {
                                    return (
                                        <Space size={8}>
                                            <Button type="link" block onClick={() => { editExtension(row) }}>{t("编辑")}
                                            </Button>
                                            <Popconfirm
                                                title={`${t("确认移除")}？`}
                                                onConfirm={() => { removeSystemExtension(id) }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Button type="link" block>{t("移除")}</Button>
                                            </Popconfirm>
                                        </Space>
                                    )
                                }}
                            ></Table.Column>
                        </Table>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { allowManually() }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick() }}>{t("删除规则")}</Button>
                        </div>

                        <Modal
                            confirmLoading={loading}
                            open={extensionModalVisible}
                            maskClosable={false}
                            destroyOnClose={true}
                            title={`${isEditExtension ? t("编辑系统扩展") : t("添加系统扩展")}`}
                            forceRender={true}
                            onOk={() => { addTemplateClick() }}
                            onCancel={() => { setExtensionModalVisible(false); dataForm.resetFields(); setSelectedExtensionId(""); setEnumExtension("AllowedSystemExtensions") }}
                            okText={t("确认")}
                            cancelText={t("取消")}
                        >
                            <Form
                                form={dataForm}
                                layout="vertical"
                                initialValues={{extensionMode: "AllowedSystemExtensions"}}
                            >
                                <Form.Item label={t("系统扩展类型")} name="extensionMode" rules={[{required: true}]}>
                                    <Select onChange={(value: string) => { setEnumExtension(value); }}>
                                        <Select.Option value="AllowedSystemExtensions">{t("允许的系统扩展")}</Select.Option>
                                        <Select.Option value="AllowedTeamIdentifiers">{t("允许的团队标识符")}</Select.Option>
                                        <Select.Option value="AllowedSystemExtensionTypes">{t("允许的系统扩展类型")}</Select.Option>
                                    </Select>
                                </Form.Item>
                                {enumExtension !== "AllowedTeamIdentifiers" && <>
                                    <Form.Item label={t("团队标识符")} name="teamIdentifier" rules={[{required: true}]}>
                                        <Input></Input>
                                    </Form.Item>
                                </>}
                                {enumExtension === "AllowedTeamIdentifiers" && <>
                                    <Form.Item label={`${t("团队标识符")}(${t("每行一个")})`} name="teamIdentifierList" rules={[{required: true}]}>
                                        <Input.TextArea rows={4} />
                                    </Form.Item>
                                </>}
                                {enumExtension === "AllowedSystemExtensions" && <>
                                    <Form.Item name="allowRemovableSystemExtension" valuePropName="checked">
                                        <Checkbox>
                                            <Space>
                                                <span>{t("允许移除此系统扩展")}  </span>
                                                <Tooltip title={t("可在macOS12及更高版本中使用")}>
                                                    <Tag color="cyan">macOS 12</Tag>
                                                </Tooltip>
                                            </Space>
                                        </Checkbox>
                                    </Form.Item>
                                    <Form.List name="packageList">
                                        {(fields, { add, remove }) => (
                                            <>
                                                {fields.map((field) => (
                                                    <Form.Item key={field.key} label={t("程序包标识")}>
                                                        <Row justify="space-between">
                                                            <Col span="21">
                                                                <Form.Item noStyle
                                                                    {...field}
                                                                    name={[field.name]}
                                                                    // fieldKey={[field.fieldKey]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col>
                                                                <Button type="dashed" onClick={() => { remove(field.name) }}>-</Button>
                                                            </Col>
                                                        </Row>
                                                    </Form.Item>
                                                ))}
                                                <Form.Item>
                                                    <Button type="dashed" onClick={() => { add() }} block>
                                                        <PlusOutlined />{t("程序包标识")}
                                                    </Button>
                                                </Form.Item>
                                            </>
                                        )}
                                    </Form.List>
                                </>}
                                {enumExtension === "AllowedSystemExtensionTypes" && <>
                                    <Form.Item label={t("扩展类别")} name="extensionType">
                                        <Select mode="multiple">
                                            <Select.Option value="DriverExtension">{t("驱动扩展")}</Select.Option>
                                            <Select.Option value="EndpointSecurityExtension">{t("终端安全")}</Select.Option>
                                            <Select.Option value="NetworkExtension">{t("网络扩展")}</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </>}
                            </Form>
                        </Modal>
                    </>
                )}
            </Row>
        </div>
    </>);
};